import { Component, Input, ViewChild, OnInit, Inject } from '@angular/core';
import { SuiModalService, TemplateModalConfig, ModalTemplate } from 'ng2-semantic-ui';
import { HttpClient } from '@angular/common/http';

import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import * as firebase from 'firebase/app';

import { SuiLocalizationService } from "ng2-semantic-ui";
import pt from "ng2-semantic-ui/locales/pt";

import 'moment/locale/pt-br';
import * as moment_ from 'moment';
const moment = moment_;
moment.locale('pt-br');

import { VqsAuthService } from '@vqs/vqs-app';
import { VqsAppService } from '@vqs/vqs-app';

export interface IContext { item: any; }
export interface TicketsItems { status: string; priority: number; }

@Component({
  selector: 'vqs-tickets',
  templateUrl: './vqs-tickets.component.html',
  styleUrls: ['./vqs-tickets.component.css']
})
export class VqsTicketsComponent implements OnInit {

  @Input() config: any;

  @ViewChild('modalTemplateNewTicket', { static: true })
  public modalTemplateNewTicket: ModalTemplate<IContext, string, string>

  TicketsItems$: Observable<TicketsItems[] | any>;

  numberFilter$: BehaviorSubject<number | null>;
  requesterFilter$: BehaviorSubject<string | null>;
  attendantFilter$: BehaviorSubject<string | null>;
  statusFilter$: BehaviorSubject<string | null>;
  folderFilter$: BehaviorSubject<string | null>;
  qtdMonthFilter$: BehaviorSubject<number | 1>;

  public selectedNumber: number;
  public selectedStatus = 'O';
  public selectedFolder: string;

  public qtdMonth: number;

  public attendants: any = [];
  public selectedAttendant: string;

  public requesters: any = [];
  public selectedRequester: string;

  public departaments: any = [];
  public selectedDepartament: string;

  public selectedTicket: any = [];

  public ticket = { signature: '' };
  public today: any;

  public btnRefreshTicketLoading: boolean;

  public statusOpt: any = [
    { id: 'O', name: 'TICKETS.STATUS.OPEN' },
    { id: 'C', name: 'TICKETS.STATUS.CLOSE' }
  ];

  public folderOpt: any = [];

  constructor(
    @Inject('vqsAppConfig') public vqsAppConfig,
    private modalService: SuiModalService,
    public localizationService: SuiLocalizationService,
    private readonly afs: AngularFirestore,
    public vqsAuthService: VqsAuthService,
    public vqsAppService: VqsAppService,
    private http: HttpClient
    ) {
      localizationService.load("pt", pt);
      localizationService.setLanguage("pt");

      this.selectedAttendant = (this.vqsAuthService.profile >= 200) ? this.vqsAuthService.userId : null;
      this.selectedRequester = (this.vqsAuthService.profile < 200) ? this.vqsAuthService.userId : null;
  }


  ngOnInit() {
    /*
    this.vqsAuthService.dbS.collection('tickets')
      .get().then(snapshot => {
        snapshot.forEach(doc => {
          if(typeof(doc.data().number) === 'string') {
            // this.vqsAuthService.dbS.collection('tickets').doc(doc.data().number).update({ number: Number(doc.data().number)});
            console.log( typeof(doc.data().number) );
          }
        })
      })
    */
    this.qtdMonth = 1;
    this.today = moment();
    this.numberFilter$ = new BehaviorSubject(null);
    this.requesterFilter$ = new BehaviorSubject(this.selectedRequester);
    this.attendantFilter$ = new BehaviorSubject(this.selectedAttendant);
    this.statusFilter$ = new BehaviorSubject(this.selectedStatus);
    this.folderFilter$ = new BehaviorSubject(this.selectedFolder);
    this.qtdMonthFilter$ = new BehaviorSubject(this.qtdMonth);

    this.vqsAuthService.dbS.collection("users").doc(this.vqsAuthService.userId).get()
    .then((doc) => {
      if (doc.exists) {
        this.ticket.signature = doc.data().signature ? doc.data().signature : '';
      }

      this.requesters = [];
      this.vqsAuthService.dbS.collection('users').orderBy('name')
      .get().then(snapshotUsers => {
        snapshotUsers.forEach(docUser => {
          if(docUser.data().profile <= 199) {
            let data = {
              id: docUser.id,
              name: docUser.data().name,
              email: docUser.data().email
            }
            if((this.config) &&
               (this.config.requesterIsChildOf) &&
               (docUser.data()[this.config.requesterIsChildOf])) {
              data[this.config.requesterIsChildOf] = docUser.data()[this.config.requesterIsChildOf]
            }
            this.requesters.push(data);
          }
          else
          if((this.vqsAuthService.profile >= 200) ||
            (docUser.id === this.vqsAuthService.userId)) {
            this.attendants.push({
              id: docUser.id,
              name: docUser.data().name,
              email: docUser.data().email,
              photo: docUser.data().photo
            });
          }
        });

        this.TicketsItems$ = combineLatest(
          this.numberFilter$,
          this.requesterFilter$,
          this.attendantFilter$,
          this.statusFilter$,
          this.folderFilter$,
          this.qtdMonthFilter$
        ).pipe(
          switchMap(([num, requester, attendant, status, folder, qtdMonth]) =>
            this.afs.collection('tickets', ref => {
              let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref.orderBy('number', 'desc').orderBy('priority');

              const timestampIni = moment().subtract(qtdMonth, 'month').unix();
              const timestampEnd = qtdMonth > 1 ? moment().subtract(qtdMonth - 1, 'month').unix() : 0;

              if (!num) {
                 query = query.where('number', '>=', timestampIni);
                 if (timestampEnd) { query = query.where('number', '<', timestampEnd); }
              };

              if (num) {
                query = query.where('number', '>=', num);
                query = query.where('number', '<=', num);
              };
              if (requester) { query = query.where('requester', '==', requester) };
              if (attendant) { query = query.where('attendant', '==', attendant) };
              if (status) { query = query.where('status', '==', status) };
              if (folder) { query = query.where('folder', '==', folder) };

              if ((this.config) &&
                  (this.config.where) &&
                  (this.config.where.field) &&
                  (this.config.where.operator)) {
                query = query.where(this.config.where.field, this.config.where.operator, this.config.where.value);
              }
              else
              if ((this.config) &&
                  (this.config.where) &&
                  (typeof(this.config.where) === 'object')) {
                for (const key in this.config.where) {
                  if (this.config.where.hasOwnProperty(key)) {
                    if ((this.config.where[key]) &&
                        (this.config.where[key].field) &&
                        (this.config.where[key].operator)) {
                      query = query.where(this.config.where[key].field, this.config.where[key].operator, this.config.where[key].value);
                    }
                  }
                }
              }

              return query
            }).valueChanges()
          )
        )
      })
    })

    this.folderOpt = [];
    this.folderOpt.push({
      id: null,
      name: 'Todas'
    });
    this.vqsAuthService.dbS.collection('folder_tickets').orderBy('name')
    .get().then(snapshotFolders => {
      snapshotFolders.forEach(docFolder => {
        this.folderOpt.push({
          id: docFolder.id,
          name: docFolder.data().name
        });
      });
    });
  }


  filterByFolder(forder: string | null) {
    this.folderFilter$.next(forder);
    this.selectedTicket = [];
  }

  filterByStatus(status: string | null) {
    this.statusFilter$.next(status);
    this.selectedTicket = [];
  }

  filterByQtdMonth(number: number | null) {
    if (number > 0) { this.qtdMonth++; } else { this.qtdMonth--; }
    this.qtdMonthFilter$.next(this.qtdMonth);
    this.selectedTicket = [];
  }

  filterByNumber(number: number | null) {
    this.requesterFilter$.next(null);
    this.attendantFilter$.next(null);
    this.numberFilter$.next(number);
    this.selectedTicket = [];
  }

  filterByRequester(requester: string | null) {
    this.requesterFilter$.next(requester);
    this.selectedTicket = [];
  }

  filterByAttendant(attendant: string | null) {
    this.attendantFilter$.next(attendant);
    this.selectedTicket = [];
  }

  refreshTicket() {
    this.btnRefreshTicketLoading = true;
    const url = this.vqsAppConfig.tickets.urlRobot;
    this.http.get(url).subscribe((data:  Array<object>) => {
      this.btnRefreshTicketLoading = false;
    },(error:  Array<object>) => {
      console.log(error);
      this.btnRefreshTicketLoading = false;
    });
  }

  getMessages(ticket) {
    this.selectedTicket = ticket;
  }


  newTicket() {
    let item = {
      id: null,
      email: ((this.config) && (this.config.newTickets) && (this.config.newTickets.message) && (this.config.newTickets.message.email)) ? this.config.newTickets.message.email : null,
      email_cc: null,
      email_cco: null,
      subject: null,
      message: this.ticket.signature ? ('<br>' + this.ticket.signature) : '',
      priority: 3,
      attendant: (this.vqsAuthService.profile > 200) ? this.vqsAuthService.userId : null,
      due_timestamp: 0,
      requester: ((this.config) && (this.config.newTickets) && (this.config.newTickets.requester)) ? this.config.newTickets.requester : (this.vqsAuthService.profile < 200) ? this.vqsAuthService.userId : null,
      requesters: [],
      departaments: ((this.config) && (this.config.newTickets) && (this.config.newTickets.departaments)) ? this.config.newTickets.departaments : [],
    }

    if ((this.config) &&
    (this.config.where) &&
    (this.config.where.value) &&
    (this.config.where.field) &&
    (this.config.where.field !== 'users')) {
      item.requesters = [];
      for(let i=0;i<=this.requesters.length;i++) {
        if((this.requesters[i]) &&
           (this.requesters[i][this.config.where.field]) &&
           (this.requesters[i][this.config.where.field] === this.config.where.value)) {
            item.requesters.push(this.requesters[i])
        }
      }
    }

    const config = new TemplateModalConfig<IContext, string, string>(this.modalTemplateNewTicket);
    config.isClosable = false;
    config.isFullScreen = true;
    config.mustScroll = false;
    config.context = { item: item };
    this.modalService
      .open(config)
      .onDeny(result => {  })
      .onApprove(result => {  });
  }


}
